import ActivityPreviewLink from "PFApp/components/activity_commons/activity_preview_link";
import { ActivityCustomValuesList } from "PFApp/components/custom_values_list";
import { useActivityNameAndId } from "PFCore/helpers/activities";
import PropTypes from "prop-types";

import css from "./content.module.scss";
import Description from "./description";

const EngagementContent = ({ task, isFeed }) => {
  const getRoleNameId = useActivityNameAndId();
  const { name, id } = getRoleNameId(task);

  const brands = task.custom_fields.find((item) => item.type.name === "brands");

  return (
    <div className={css.wrapper}>
      <ActivityPreviewLink activity={task}>
        <div className={css.header}>
          <h3>{name}</h3>
          {id && <div>{`ID: ${id}`}</div>}
        </div>
        <div className={css.description}>
          <Description description={task.description} id={task.id} />
        </div>
        {brands && (
          <ActivityCustomValuesList
            customFieldName="brands"
            customValues={brands.values}
            activityId={task.id}
            maxNameLength={isFeed ? 25 : undefined}
          />
        )}
      </ActivityPreviewLink>
    </div>
  );
};

EngagementContent.propTypes = {
  task: PropTypes.shape({
    id: PropTypes.number,
    template_id: PropTypes.number,
    name: PropTypes.string,
    description: PropTypes.string,
    metadata: PropTypes.shape({
      location: PropTypes.string
    }),
    custom_fields: PropTypes.array,
    created_at: PropTypes.string
  }),
  isFeed: PropTypes.bool
};

export default EngagementContent;
